module.exports = __webpack_public_path__ + "img/1.c94d539b.jpg";